<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-toolbar color="green darken-4" dark>
          <v-toolbar-title>Audience Insight</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p class="title">
            Unlock Audience Insights.
            Join our 1 year membership program for just $4.29 per year!
          </p>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// AudienceInsightPreview.vue?6bafc4d0